import { render, staticRenderFns } from "./LessonsAutoCreatePage.vue?vue&type=template&id=4cd8f844&lang=pug&"
import script from "./LessonsAutoCreatePage.vue?vue&type=script&lang=js&"
export * from "./LessonsAutoCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports